import React from 'react'
import PropTypes from 'prop-types'

// Reusable wrapper that hides children via visibility:hidden.
// The children remain in the layout and occupy their normal space.
const GlgHiddenWrapper = ({ children }) => {
  return (
    <div className={'glg-hidden-element-wrapper'}>
      {children}
    </div>
  )
}

GlgHiddenWrapper.propTypes = {
  children: PropTypes.node.isRequired,
}

export default GlgHiddenWrapper
